import React from "react";

export const QA_META = {
  on_track: { label: "On Track", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  monitor: { label: "Monitor", cls: "bg-yellow-50 text-yellow-700 border-yellow-200" },
  intervention_recommended: { label: "Intervention", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  reassignment_recommended: { label: "Reassign Rec.", cls: "bg-red-50 text-red-700 border-red-200" },
  immediate_reassignment: { label: "Reassign Now", cls: "bg-red-100 text-red-800 border-red-300" },
  escalated: { label: "Escalated", cls: "bg-red-600 text-white border-red-700" },
  complete: { label: "Complete", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  no_deadline: { label: "No Deadline", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  not_monitored: { label: "—", cls: "bg-slate-50 text-slate-400 border-slate-200" },
};

export function QaBadge({ status, testid }) {
  const m = QA_META[status] || QA_META.not_monitored;
  return (
    <span data-testid={testid} className={`inline-block rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${m.cls}`}>
      {m.label}
    </span>
  );
}
